import {MenuLinkInterface} from './MenuLinkInterface.ts'
import NavItemCustom from '../../../../router/NavItemCustom';

interface MenuInternalLinkInterface extends MenuLinkInterface {
    index: number;
    onClick: Function;
}
export const MenuInternalLink = ({
    menu,
    className,
    index,
    onClick
}: MenuInternalLinkInterface) => {
    return (
        <NavItemCustom
            eventKey={String(index)}
            toPathname={menu.pathName}
            onClick={onClick}
            classnamelink={className}
            iconName={menu.icon}
            title={menu.title}
            badge={menu.badge || false}
        />
    )
}